import Vue from 'vue';
import axios from 'axios';
import config from '@/config';
import { getSelectedVenue } from '@/services/helpers';
import { client } from '@/services';

const devicesService = client.service('devices');
const devices = {
	namespaced: true,
	state: {
		devices: []
	},
	getters: {
		GET_DEVICES: (state) => {
			var distinct = [];

			state.devices.forEach(device => {
				if (device.venueId == getSelectedVenue()._id) {
					if (distinct.length > 0) {
						if (!distinct.some(item => item._id === device._id)) {
							distinct.push(device);
						}
					} else {
						distinct.push(device);
					}
				}
			});

			return distinct;
		}
	},
	mutations: {
		SET_DEVICES(state, devices) {
			state.devices = devices;
		},
		ADD_MORE_DEVICES(state, devices) {
			state.devices = Array.from(new Set(state.devices.concat(devices)));
		},
		ADD_DEVICE(state, device) {
			state.devices.push(device);
		},
		UPDATE_DEVICE(state, device) {
			const i = state.devices.findIndex((d) => d._id === device._id);

			if (i !== -1) {
				Vue.set(state.devices, i, device); // reactivity hack
			}
		},
		UPDATE_DEVICE_STATUS(state, data) {
			const i = state.devices.findIndex((d) => d.serial === data.client_id);
			const device = state.devices[i];
			device.status = Object.assign({}, data);
			Vue.set(state.devices, i, device); // reactivity hack
		},
		REMOVE_DEVICE(state, _id) {
			const i = state.devices.findIndex((d) => d._id === _id);

			if (i > 0) {
				state.devices.splice(i, 1);
			}
		}
	},
	actions: {
		async GET_DEVICES({ commit, dispatch }) {
			const [groups, data] = await Promise.all([
				dispatch('groups/GET_GROUPS', null, { root: true }),

				devicesService.find({
					query: {
						venueId: getSelectedVenue()._id,
						$paginate: {
							value: false
						}
					}
				})
			]);

			const devices = data.map((device) => {
				const i = groups.findIndex((g) => g._id === device.groupId);

				device.groupName = (i >= 0) ? groups[i].name : 'No group yet.';

				return device;
			});

			commit('SET_DEVICES', devices);

			return devices;
		},
		async GET_UNASSIGNED_DEVICES({ rootState }) {
			const devices = await devicesService.find({
				query: {
					$select: ['_id', 'serial', 'name', 'address', 'ipAddress', 'connected', 'disconnected', 'venueId'],
					$paginate: {
						value: false
					}
				}
			});

			const normalized = (Array.isArray(devices) ? devices : (devices.data || [])).map(d => ({
				...d,
				address: d.address || d.ipAddress || null,
			}));

		//	const selectedVenue = getSelectedVenue();
			//console.log('selectedVenue', selectedVenue);
			return  normalized.filter(device => !device.venueId);
		},
		async GET_DASHBOARD_DEVICES({ commit, dispatch }) {
			const devices = await devicesService.find({
				query: {
					showInDashboard: true,
					$paginate: {
						value: false
					}
				}
			});

			commit('SET_DEVICES', devices);

			return devices;
		},
		async GET_MORE_DEVICES({ commit, dispatch, state }) {
			const groups = await dispatch('groups/GET_GROUPS', null, { root: true })
			const response = await devicesService.find({
				query: {
					$skip: state.devices.length
				}
			})
			const devices = response.data.map((device) => {
				const i = groups.findIndex((g) => g._id === device.groupId)
				device.groupName = (i >= 0) ? groups[i].name : 'No group yet.'
				return device
			})

			commit('ADD_MORE_DEVICES', devices)
		},
		async GET_DEVICE({ dispatch }, _id) {
			const device = await devicesService.get(_id);
			let schedules = [];
			if (device.groupId) {
				const response = await dispatch('schedules/SEARCH_DEVICE_GROUP', device.groupId, {root: true});
				if (Array.isArray(response)) {
					schedules = [...response]
				}
			}
			return { ...device, schedules };
		},
		async ADD_DEVICE({ rootState, commit }, device) {
			try {
				const result = await devicesService.find({
					query: {
						serial: device.serial
					}
				});

				if (result.data.length > 0) {
					throw {
						success: false,
						message: 'Serial already exists'
					}
					return;
				}

				device.created_at = Date.now();
				const response = await devicesService.create(device);
				const groups = rootState.groups.groups;
				const i = groups.findIndex((g) => g._id === response.groupId);
				response.groupName = (i >= 0) ? groups[i].name : 'No group yet.';
				commit('ADD_DEVICE', response);
				return response;
			} catch (e) {
				throw e;
			}
		},
		async UPDATE_DEVICE({ rootState, commit }, payload) {
			try {
				payload.device.created_at = Date.now();
				delete payload.device._id;
				delete payload.device.groupName;
				delete payload.device.licensed;
				const response = await devicesService.patch(payload._id, payload.device);
				const groups = rootState.groups.groups;
				const i = groups.findIndex((g) => g._id === response.groupId);
				response.groupName = (i >= 0) ? groups[i].name : 'No group yet.';
				commit('UPDATE_DEVICE', response);
				return response;
			} catch (e) {
				throw e;
			}
		},
		async UPDATE_DEVICES_GROUP({ commit }, payload) {
			try {
				for (let device of payload.devices) {
					if (device.groupId != payload.newGroupId) {
						device.groupId = payload.newGroupId;

						const response = await devicesService.patch(device._id, { groupId: device.groupId });

						commit('UPDATE_DEVICE', response);
					}
				}
			} catch (error) {
				throw error;
			}
		},
		async DELETE_DEVICE({ commit }, _id) {
			try {
				// console.log("BEFORE_DELETE_DEVICE: ", _id);
				await devicesService.remove(_id);
				commit('REMOVE_DEVICE', _id);
				// console.log("DELETED_DEVICE: ", _id);
			} catch (e) {
				throw e
			}
		},
		async DELETE_DEVICES({ commit }, devices) {
			try {
				for (let device of devices) {
					if (device.connected > device.disconnected) {
						return;
					}

					await devicesService.remove(device._id);

					commit('REMOVE_DEVICE', device._id);
				}
			} catch (error) {
				throw error;
			}
		},
		async UPLOAD_UPGRADE_FILE({ dispatch }, payload) {
			try {
				const formData = new FormData();
				formData.append('file', payload);

				return await axios.post(`${config.server_url}/api/device-upgrade/uploadinstaller`, formData);
			} catch (error) {
				return { success: false, err: error };
			}
		}
	}
}

export default devices;



// WEBPACK FOOTER //
// ./src/store/modules/devices.js